module.exports = __webpack_public_path__ + "static/apple-icon-180x180-ea4acd369859c8186ce17f1a70d29507.png";